import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 0 },
    threshold: { type: Number, default: 0.1 }
  }

  connect() {
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(20px)"
    this.element.style.transition = "opacity 0.6s ease-out, transform 0.6s ease-out"
    this.element.style.transitionDelay = `${this.delayValue}ms`

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animate()
            this.observer.unobserve(this.element)
          }
        })
      },
      { threshold: this.thresholdValue }
    )

    this.observer.observe(this.element)
  }

  animate() {
    this.element.style.opacity = "1"
    this.element.style.transform = "translateY(0)"
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
